import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("flowsend_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      const path = window.location.pathname;
      if (!["/login", "/signup", "/forgot-password"].includes(path)) {
        localStorage.removeItem("flowsend_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
